angular.module('pitch.track', [
    'satv.track'
])

;



// WEBPACK FOOTER //
// ./src/SMFCoreClientBundle/Resources/js/angular/app.js